// extracted by mini-css-extract-plugin
export var bottom = "challenges-module--bottom--X0BfA";
export var challenges = "challenges-module--challenges--r-DRb";
export var heading = "challenges-module--heading--9qDPl";
export var horizontalSpacer = "challenges-module--horizontalSpacer--1uvrw";
export var image = "challenges-module--image--LFuCM";
export var info = "challenges-module--info--HP6oP";
export var left = "challenges-module--left--2w1uW";
export var picture = "challenges-module--picture--aEso6";
export var play = "challenges-module--play--6-+7q";
export var recentChallenge = "challenges-module--recentChallenge--OkIl2";
export var right = "challenges-module--right--Bb2AL";
export var verticalSpacer = "challenges-module--verticalSpacer--EwC3F";